import React from "react";
import { useI18n } from "@/lib/i18n";
import { Sparkles, Droplets, Shield, Wrench, Diamond, Layers, Hammer, ClipboardList, ArrowUpRight } from "lucide-react";

const ICONS = [Sparkles, Droplets, Shield, Wrench, Diamond, Layers, Hammer, ClipboardList];

export default function Services({ onConsult }) {
  const { t } = useI18n();

  return (
    <section id="services" data-testid="services-section" className="relative bg-onyx py-24 lg:py-40">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="grid grid-cols-12 gap-6 mb-16 lg:mb-24">
          <div className="col-span-12 lg:col-span-5">
            <div className="eyebrow mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-brass" /> {t.services.eyebrow}
            </div>
            <h2 className="font-display text-[2.6rem] sm:text-5xl lg:text-7xl text-bone leading-[1] tracking-tight">
              {t.services.title_1} <span className="italic-display text-brass">{t.services.title_2}</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-bone/70 leading-relaxed text-base lg:text-lg max-w-2xl">
              {t.services.lead}
            </p>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-bone/5 border border-bone/5">
          {t.services.list.map((s, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <button
                key={i}
                onClick={onConsult}
                data-testid={`service-card-${i}`}
                className="group relative bg-onyx p-8 lg:p-10 text-left flex flex-col gap-6 transition-colors duration-500 hover:bg-charcoal min-h-[260px]"
              >
                <div className="flex items-start justify-between">
                  <div className="w-11 h-11 grid place-items-center border border-bone/15 group-hover:border-brass group-hover:text-brass text-bone/70 transition-colors duration-500">
                    <Icon className="w-5 h-5" strokeWidth={1.4} />
                  </div>
                  <span className="text-[0.7rem] tracking-[0.2em] uppercase text-taupe group-hover:text-brass transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <div className="flex-1 flex flex-col">
                  <h3 className="font-display text-2xl lg:text-[1.6rem] text-bone leading-tight tracking-tight">{s.t}</h3>
                  <p className="mt-3 text-sm text-bone/60 leading-relaxed">{s.d}</p>
                </div>
                <div className="flex items-center gap-2 text-[0.7rem] tracking-[0.2em] uppercase text-brass opacity-0 group-hover:opacity-100 -translate-y-1 group-hover:translate-y-0 transition-all duration-500">
                  {t.cta.more} <ArrowUpRight className="w-3.5 h-3.5" />
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
